<template>
    <div class="d-inline-block align-top mb-2">
        <multiselect track-by="key"
                     :options="options"
                     :searchable="searchable"
                     label="name"
                     :multiple="multiple"
                     :allow-empty="empty"
                     :close-on-select="false"
                     :limit="limit" :limitText="limitText"
                     :show-labels="false"
                     :placeholder="trans[locale].selectionLang.search"
                     :customLabel="customLabel"
                     :clear-on-select="!multiple"
                     group-values="libs"
                     group-label="language"
                     :group-select="group_select"
                     @input="updateValueAction" v-model="selected">

            <template slot="placeholder" slot-scope="props">
                <span>{{ placeholder }}</span>
            </template>

            <!-- shows when no options in selection -->
            <template slot="noResult" slot-scope="props">
                <span>No result</span>
            </template>

        </multiselect>
    </div>
</template>

<script>

    export default {

        data() {
            return {
                selected: [],
                options: this.init_options,
                value: '',
                locale: window.locale,
                placeholder: this.init_placeholder,
            }
        },
        props: {
            filter: {
                type: String,
                required: true,
            },
            init_options: {
                type: Array,
                required: true,
            },
            multiple: {
                type: Boolean,
                default: false,
            },
            trigger_filter_refresh: {
                type: Boolean,
                default: false,
            },
            ignore_refresh_signal: {
                type: Boolean,
                default: false,
            },
            refresh_url: {
                type: String,
                default: '',
            },
            init_selected: {
                type: Array,
                default: () => [],
            },
            init_placeholder: {
                type: String,
                default: () => this.trans[this.locale].selectionLang.placeholder,
            },
            searchable: {
                type: Boolean,
                default: true,
                required:false
            },
            group_select: {
                type: Boolean,
                default: true,
                required:false
            }
        },
        beforeDestroy() {
            if (!this.ignore_refresh_signal) {
				window.eventHub.$off('filter_refresh', this.fetchOption)
            }
        },
        mounted() {
            if (_.size(this.options) >0 ) {
                _.forEach(this.options, (group) => {
                    if (!_.isUndefined(group['libs']) && _.size(group['libs']) > 0) {
                        _.forEach(group['libs'], (option) => {
                            if (_.indexOf(this.$store.state.filters[this.filter], option.key) !== -1 ||
                                this.$store.state.filters[this.filter] == option.key) {
                                this.selected.push(option);
                            }
                        });
                    }
                });
            }

            let load_init_selected = false;
            if (this.selected.length == 0) {
                if (_.isUndefined(this.$store.state.filters[this.filter]) ||
                    _.size(this.$store.state.filters[this.filter].length) == 0 ||
                    _.isEmpty(this.$store.state.filters[this.filter])
                ) {
                    load_init_selected = true;
                } else {
                    load_init_selected = false;
                }
            }

            // Add init selected value into final selected v-model
            let self = this;
            if (load_init_selected) {
                _.each(this.init_selected, value => {
                    if (_.find(self.selected, ['key', value]) === undefined) {
                        _.forEach(self.options, (group_option) => {
                            let _selected = _.find(group_option['libs'], ['key', value]);
                            if (_selected)
                                self.selected.push(_selected);
                        });
                    }
                })
            }
            this.updateValueAction(this.selected);

            if (!this.ignore_refresh_signal) {
				window.eventHub.$on('filter_refresh', this.fetchOption)
            }
            else if (this.trigger_filter_refresh) {
                this.$nextTick(() => {
					window.eventHub.$emit('filter_refresh', this.selected.map(item => item.key));
                });
            }
        },
        methods: {
            customLabel({key, name}) {
                return `${name}`
            },
            updateValueAction(values) {
                let _values = Array.isArray(values) ?
                    values : (values ? [values] : []);
                let _value = _values.map(value => value.key)
                let _filter = this.filter

                // emit a refresh signal to other filters
                if (this.trigger_filter_refresh) {
					window.eventHub.$emit('filter_refresh', _value);
                }

                this.$store.commit('setFilter', {_filter, _value});
            },
            limitText(count) {
                return `${this.trans[this.locale].selectionLang.selected} (${count})`;
            },
            fetchOption(year_id) {
                if (this.refresh_url) {
                    let self = this;

                    self.$store.commit('setSubmitting', true);
                    axios.get(this.refresh_url + '/' + year_id)
                        .then((response) => {
                            self.$nextTick(() => {
                                // update selection
                                self.options = response.data;

                                if (_.size(self.options) >0 ) {
                                    _.forEach(self.options, (group) => {
                                        if (!_.isUndefined(group['libs']) && _.size(group['libs']) > 0) {
                                            _.forEach(group['libs'], (option) => {
                                                if (_.indexOf(self.$store.state.filters[self.filter], option.key) !== -1 ||
                                                    self.$store.state.filters[self.filter] == option.key) {
                                                    self.selected.push(option);
                                                }
                                            });
                                        }
                                    });
                                }

                                // refresh selected options
                                self.selected = _.filter(self.selected, function (o) {
                                    return _.find(self.options, ['key', o.key]) !== undefined;
                                });

                                // reset filter state
                                let _filter = self.filter;
                                let _value = self.selected.map(item => item.key);
                                self.$store.commit('setFilter', {_filter, _value});
                            })

                            self.$store.commit('setSubmitting', false);
                        })
                        .catch((error) => {
                            self.$store.commit('setNotificationType', 'danger');
                            self.$store.commit('setNotification', error.response.data.message);
                            self.$store.commit('setSubmitting', false);
                        })
                }
            },
        },
        computed: {
            limit() {
                return this.multiple ? 0 : 1;
            },
            empty() {
                return this.multiple ? true : false;
            }
        },
    }
</script>



// WEBPACK FOOTER //
// resources/assets/js/components/Select/FilterGroup.vue